import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/defaults')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasAnyPermission(['sites:manage'])) {
      throw redirect({ params: { siteId: params.siteId }, to: '/settings/sites/$siteId' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/sites/pages/site-defaults-page')),
});
